import { useListContext, useVersion } from "ra-core"
import { FC } from "react"
import { OdResourcePageProps } from "~/types/resource"
import { Box, Card, CardHeader, Chip, Divider} from '@mui/material'
import Scrollbar from '~/components/Scrollbar'
import { Datagrid } from '~/components/list/datagrid'
import TextField from '~/components/field/TextField'
import { Pagination as DefaultPagination } from '~/components/list/pagination'
import StartInvite from "./StartInvite"
import { EmailField, FunctionField } from "~/components/field"
import { UserInvitationResponseDto } from "~/gen/api/user"
import { RecPatch } from "~/dataProvider/tools"
import DeleteButton from "~/components/button/DeleteButton"
import DateField2 from "~/components/field/DateField2"
import { useDefaultSavedHandlers } from "~/controller/defaultSavedHandlers"
import { useHasPermit } from "~/authProvider/useHasPermit"
import { ORGANIZATION_USERS } from "~/constants"
import UserInvitationsTableSearchProvider from "./UserInvitationsTableSearchProvider"
import UserInvitationsTableSearchRegion from "./UserInvitationsTableSearchRegion"



const InvitationTable: FC<OdResourcePageProps> = (props) => {
  const hasWritePermit = useHasPermit([ORGANIZATION_USERS])
  const listContext = useListContext({ resource: 'user-invitation' })
  const version = useVersion()
  const handlers = useDefaultSavedHandlers("Delete User Invitation")
  handlers.onSuccess.merge(listContext.refetch)

  return (
    <Card>
      <CardHeader
        action={hasWritePermit && <StartInvite />}
        title="User Invitations"
      />
      <Divider />
      <UserInvitationsTableSearchProvider>
        <UserInvitationsTableSearchRegion />
      </UserInvitationsTableSearchProvider>
      <Divider />
      <Scrollbar>
        <Box 
          sx={{ 
            minWidth: 1150,
            '& th:last-of-type': { textAlign: 'center' },
          }}
        >

          <Datagrid hasBulkActions={false} {...listContext }>
            <EmailField source="email" label="Email" sortable={false} />
            <TextField source="rolesText" label="Role" sortable={false} />
            <FunctionField 
              source="isExpired" 
              label="Status" 
              sortable={false}
              render={(record?: UserInvitationResponseDto & RecPatch) =>
                <Chip 
                  label={record?.isExpired ? 'Expired' : 'Pending'}
                  variant="outlined"
                  color={(record?.isExpired ? 'error' : 'success') as any}
                />
              }
            />
            <DateField2 source="createdTime" label="Invitation Sent" showTime={true} sortable={false} />
            <TextField source="inviteeName" label="Invitation From" sortable={false} />
            {hasWritePermit &&
              <FunctionField 
                source="email" 
                label="Action" 
                sortable={false}
                textAlign="center"
                render={(record?: UserInvitationResponseDto & RecPatch) =>
                  <DeleteButton resource="user-invitation" record={record} basePath="" {...handlers}/>
                }
              />}
          </Datagrid>

        </Box>
      </Scrollbar>
      {//@ts-ignore
        <DefaultPagination {...listContext} />}
    </Card>
  )
}

export default InvitationTable;
